import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect } from "react";

export function CountUp({ value, className, prefix = "", suffix = "", decimals = 0 }) {
  const mv = useMotionValue(0);
  const rounded = useTransform(mv, (latest) =>
    `${prefix}${Number(latest).toLocaleString("it-IT", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    })}${suffix}`
  );

  useEffect(() => {
    const controls = animate(mv, Number(value || 0), { duration: 0.9, ease: "easeOut" });
    return controls.stop;
  }, [value, mv]);

  return <motion.span className={className}>{rounded}</motion.span>;
}
